import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { DomainsAggregationsConfig } from '../Aggregations/DomainsAggregationsConfig';
import { combineApiConfigs } from '@wix/premium-fed-sdk/@apis-infra';
import { DomainsApiConfig } from '../../apiConfigurations';
export const DomainsApiClient = createApiClient(combineApiConfigs(DomainsAggregationsConfig, DomainsApiConfig));
//# sourceMappingURL=DomainsApiClient.js.map